import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { AdminBannerStatus } from '../../enums/admin-banner-status';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { AdminBannerContextOperationsResponse } from './admin-banner-context-operations.response';
import { BannerLocationType } from '../../../shared/enums/banner-location-type';

@jsonObject
export class AdminBannerCollectionItemResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly status!: AdminBannerStatus;

  @jsonMember(String)
  public readonly url?: Nillable<string>;

  @jsonMember(String)
  public readonly location?: Nillable<BannerLocationType>;

  @jsonMember(Date)
  public readonly createdAt!: Nillable<Date>;

  @jsonMember(Date)
  public readonly visibilityStartDate?: Nillable<Date>;

  @jsonMember(Date)
  public readonly visibilityEndDate?: Nillable<Date>;

  @jsonMember(MultimediaResponse)
  public readonly file!: MultimediaResponse;

  @jsonMember(AdminBannerContextOperationsResponse)
  public readonly contextOperations!: AdminBannerContextOperationsResponse;
}
